import EventEmitter from 'events';
import forEach from 'lodash/forEach';
import Events from '../Events';
import mediaEvents from '../mediaEvents';
import companionEvents from './companionEvents';
import { isDynamicAdContent } from './injectCompanionAd';
import injectDynamicAdContent from './injectDynamicAdContent';
import injectStaticAdContent from './injectStaticAdContent';
import injectStaticInstreamAdContent from './injectStaticInstreamAdContent';
function getInstreamAdElement(slotElement, width, height, content) {
    if (content.staticResource) {
        return injectStaticInstreamAdContent(slotElement, content);
    }
    if (content.htmlResource) {
        return injectDynamicAdContent(slotElement, content.htmlResource, width, height);
    }
    return undefined;
}
function getDefaultAdElement(slotElement, width, height, content) {
    return isDynamicAdContent(content)
        ? injectDynamicAdContent(slotElement, content, width, height)
        : injectStaticAdContent(slotElement, content);
}
export default class CompanionAdManager extends EventEmitter {
    constructor(companionCache) {
        super();
        this.companionCache = companionCache;
    }
    renderCompanionAd(slotElement, slot, width, height, content) {
        try {
            const element = getInstreamAdElement(slotElement, width, height, content) ||
                getDefaultAdElement(slotElement, width, height, content);
            if (!element) {
                this.emit(companionEvents.clickError, slot);
                return;
            }
            mediaEvents.event(Events.Media.display, Events.Status.loaded).emit({
                slot,
                isInstream: content.isInstream,
                isCompanionAd: true,
            });
            setTimeout(() => {
                mediaEvents.event(Events.Media.display, Events.Status.viewable).emit({
                    slot,
                    isCompanionAd: true,
                    isInstream: content.isInstream,
                    isViewable: global.document.hasFocus() && slot.isAdSlotVisible(),
                });
            }, 1000);
            element.addEventListener('click', () => this.emit(companionEvents.clicked, slot));
        }
        catch (ex) {
            this.emit(companionEvents.renderError, { slot, error: ex });
        }
    }
    processCompanionAds(companionAds, displaySlots, adSlotProvider) {
        this.companionCache.loadDisplaySlots(displaySlots);
        forEach(companionAds, (ad) => {
            const { width, height, content } = ad;
            const slot = this.companionCache.getCompanionSlot(width, height, adSlotProvider);
            if (slot) {
                this.companionCache.removeDisplaySlot(width, height, adSlotProvider);
                mediaEvents.event(Events.Media.display, Events.Status.response).emit({
                    slot: {
                        formatDefinition: {
                            ...slot.format,
                        },
                        requestId: '',
                        isCompanionAd: true,
                    },
                });
                this.emit(companionEvents.loaded, { ...slot, width, height, content });
            }
        });
        const slotIds = this.companionCache.displaySlotIds;
        forEach(slotIds, (elementId) => {
            this.emit(companionEvents.refreshDisplaySlot, elementId);
        });
        this.companionCache.reset();
    }
}
